import { useRef, ReactElement } from 'react';
import {
  Container, Row, Col, Button,
} from 'react-bootstrap';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useNavigate, Link } from 'react-router-dom';
import { InputUnform, load } from '../../components';
import { api, alerts } from '../../utils';
import validarErroForm from './validar-erro-form';

const baseApi = process.env.REACT_APP_BASE_API;
const messageHtml = `
  <html lang="pt">
    <body>
      <a href="${baseApi}/change-password/{{token}}">
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;">
            Clique aqui para redefinir sua senha
          </font>
        </font>
      </a>
      <br />
      <br />
      <span>
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;">
            ou copie e cole este link em seu navegador: ${baseApi}/change-password/{{token}}
          </font>
        </font>
      </span>
    </body>
  </html>
`;

const ForgotPassword = (): ReactElement => {
  const navigate = useNavigate();

  const formRef = useRef<FormHandles>(null);

  const handleForgotPassword = async (data: { username: string }) => {
    try {
      formRef.current?.setErrors({});

      await validarErroForm(data);

      load.show();

      await api.enviarEmail({
        ...data,
        message: messageHtml,
      });

      navigate('/login');

      alerts.exibirToastSuccess(
        'Siga as instruções em seu email para redefinir sua senha',
        { autoClose: 15000 },
      );
    } catch (error) {
      alerts.exibirErrorCatch(error, formRef);
    } finally {
      load.hide();
    }
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xl={6} lg={12} md={9}>
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <Row>
                <Col lg={12}>
                  <div className="p-5">
                    <div className="text-center">
                      <h1 className="h4 text-gray-900 mb-2">
                        Recuperação de senha:
                      </h1>
                      <p className="mb-4">
                        Você receberá um email com um link para cadastrar uma
                        nova senha de acesso ao sistema.
                      </p>
                    </div>
                    <Form ref={formRef} onSubmit={handleForgotPassword}>
                      <div className="form-group">
                        <InputUnform
                          key="forgot-password"
                          type="text"
                          name="username"
                          className="form-control form-control-user"
                          placeholder="Usuário"
                        />
                      </div>
                      <Button
                        className="btn btn-primary btn-user btn-block"
                        variant="primary"
                        type="submit"
                      >
                        Enviar email
                      </Button>
                    </Form>
                    <hr />
                    <div className="text-center">
                      <Link
                        to="/login"
                        className="m--font-boldest"
                        style={{ textDecoration: 'none' }}
                      >
                        Voltar
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
